export default __webpack_public_path__ + "static/media/icon.60d1c5d6.png";